/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringdays1Inputs */

const en_recurringdays1 = /** @type {(inputs: Recurringdays1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days`)
};

const de_recurringdays1 = /** @type {(inputs: Recurringdays1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage`)
};

/**
* | output |
* | --- |
* | "days" |
*
* @param {Recurringdays1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringdays1 = /** @type {((inputs?: Recurringdays1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringdays1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringdays1(inputs)
	return de_recurringdays1(inputs)
});
export { recurringdays1 as "recurringDays" }